var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.416 7.37592C17.7606 7.60568 17.8538 8.07134 17.624 8.41598L13.0668 15.2517L10.5813 12.2691L7.63272 16.9026C7.41034 17.2521 6.94677 17.3551 6.59732 17.1327C6.24786 16.9103 6.14485 16.4468 6.36723 16.0973L10.4186 9.73081L12.9331 12.7482L16.3759 7.58393C16.6057 7.23929 17.0714 7.14616 17.416 7.37592Z",
    fill: "#B6B8D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnChart);
export default __webpack_public_path__ + "static/media/icn-chart.c8468c94009160ad917c39640c37bfa1.svg";
export { ForwardRef as ReactComponent };